import { render } from "./patient-accounts-modal.vue?vue&type=template&id=2956c700"
import script from "./patient-accounts-modal.vue?vue&type=script&lang=js"
export * from "./patient-accounts-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__